import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from './ui/card';
import { Badge } from './ui/badge';

const Skills = ({ data }) => {
  const categoryColors = [
    'from-emerald-500 to-teal-600',
    'from-blue-500 to-indigo-600',
    'from-purple-500 to-pink-600',
    'from-orange-500 to-red-600',
    'from-cyan-500 to-blue-600'
  ];

  return (
    <section id="skills" className="py-20 bg-slate-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            {data.title}
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-emerald-400 to-blue-500 mx-auto mb-6"></div>
          <p className="text-xl text-slate-400 max-w-3xl mx-auto">
            A powerful combination of offensive security, defensive strategies, and full-stack engineering capabilities—ready to tackle any technical challenge.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {data.categories.map((category, categoryIndex) => (
            <Card 
              key={categoryIndex} 
              className="bg-slate-800/50 border-slate-700 hover:bg-slate-800/70 transition-all duration-300 hover:scale-105 group"
            >
              <CardHeader className="pb-4">
                <CardTitle className={`text-xl font-bold bg-gradient-to-r ${categoryColors[categoryIndex]} bg-clip-text text-transparent group-hover:scale-105 transition-transform duration-200`}>
                  {category.title}
                </CardTitle>
              </CardHeader>
              <CardContent>
                <div className="flex flex-wrap gap-2">
                  {category.skills.map((skill, skillIndex) => (
                    <Badge
                      key={skillIndex}
                      variant="secondary"
                      className="bg-slate-700/50 text-slate-300 hover:bg-slate-700 hover:text-white transition-all duration-200 hover:scale-110 cursor-default"
                    >
                      {skill}
                    </Badge>
                  ))}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Background Image */}
        <div className="mt-16 relative">
          <div 
            className="h-64 bg-cover bg-center bg-no-repeat rounded-2xl opacity-10"
            style={{
              backgroundImage: `url('https://images.unsplash.com/photo-1691435828932-911a7801adfb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxuZXR3b3JrJTIwc2VjdXJpdHl8ZW58MHx8fHwxNzU4NDczMDA0fDA&ixlib=rb-4.1.0&q=85')`
            }}
          ></div>
        </div>
      </div>
    </section>
  );
};

export default Skills;